import React from "react";
import { Outlet } from "react-router-dom";

export function InboundLayout() {
  return (
    <div className="space-y-6">
      <div className="px-6">
        <Outlet />
      </div>
    </div>
  );
}
